import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import DownloadReport from '../report/DownloadReport';


const NavLinks = () => {
  const location = useLocation();
  const currentPath = location.pathname;
const { user, logout } = useAuth();
  const navigate = useNavigate();
  
  const dashboardPaths = ['/admin/dashboard'];
  const eventManagementPaths = [
    '/admin/event-management',
    '/admin/audience-category',
    '/admin/hotel',
    '/admin/workshop',
    '/admin/accomodation'
  ];
  const masterDataPaths = [
    '/admin/masterdata-company',
    '/admin/masterdata-contacts',
    '/admin/masterdata-individual-partner',
    '/admin/masterdata-services',
    '/admin/masterdata-scheme-category',
    '/admin/masterdata-audittype',
    '/admin/masterdata-standard',
    '/admin/masterdata-activity-list',
    '/admin/masterdata-isccscope',
    '/admin/masterdata-isccmaterialcategory',
    '/admin/masterdata-isccmaterial',
    '/admin/masterdata-source',
    '/admin/masterdata-lead-status',
    '/admin/masterdata-proposal-status',
    '/admin/masterdata-status',
    '/admin/masterdata-entity-type',
    '/admin/masterdata-business-partner-type',
    '/admin/masterdata-individual-partner-type',
    '/admin/masterdata-sector',
    '/admin/masterdata-nacecode',
    '/admin/masterdata-lvvscheme',
    '/admin/masterdata-lvvnek'
  ];
  const usersPaths = ['/admin/masterdata-internal-users', '/admin/masterdata-external-users'];
  const monitoringPaths = ['/admin/monitoring-peserta', '/admin/monitoring-pembayaran'];

  const [openDropdowns, setOpenDropdowns] = useState({
    eventManagement: false,
    masterData: false,
    monitoring: false,
    users: false
  });

  const isPathInCategory = (paths) => paths.some(path => currentPath === path);

  useEffect(() => {
    setOpenDropdowns({
      eventManagement: isPathInCategory(eventManagementPaths),
      masterData: isPathInCategory(masterDataPaths),
      monitoring: isPathInCategory(monitoringPaths),
      users: isPathInCategory(usersPaths)
    });
  }, [currentPath]);

  const toggleDropdown = (dropdown, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdown]: !prev[dropdown]
    }));
  };

  
  const handleLogout = () => {
    // Hapus token atau session di sini
    // localStorage.removeItem('token'); // atau sessionStorage, tergantung implementasi kamu

    logout();
    // Arahkan ke halaman login
    navigate('/login');
  };

  return (
    <ul className="navbar-nav pt-lg-3">
      {/* Dashboard */}
      <li className="nav-item">
        <Link className={`nav-link${isPathInCategory(dashboardPaths) ? ' active' : ''}`} to="/admin/dashboard2">
          <i className="bi bi-speedometer2 me-2" />
          Dashboard
        </Link>
      </li>
      {/* <li className="nav-item">
        <Link className={`nav-link${isPathInCategory(dashboardPaths) ? ' active' : ''}`} to="/admin/dashboard2  ">
          <i className="bi bi-speedometer2 me-2" />
          Dashboard 2
        </Link>
      </li> */}

      {/* Dropdown: Event Management */}
      <li className={`nav-item dropdown${openDropdowns.eventManagement ? ' show' : ''}`}>
        <a
          className={`nav-link dropdown-toggle${isPathInCategory(eventManagementPaths) ? ' active' : ''}`}
          href="#"
          onClick={e => toggleDropdown('eventManagement', e)}
          role="button"
          aria-expanded={openDropdowns.eventManagement}
        >
          <i className="bi bi-calendar-event-fill me-2" />
          Pengelolaan Event
        </a>
        <div className={`dropdown-menu${openDropdowns.eventManagement ? ' show' : ''}`}>
          <Link className={`dropdown-item${currentPath === '/admin/event-management' ? ' active' : ''}`} to="/admin/event-management">
            Event
          </Link>
          {/* <Link className={`dropdown-item${currentPath === '/admin/event-price' ? ' active' : ''}`} to="/admin/event-price">
            Event Price
          </Link> */}
          <Link className={`dropdown-item${currentPath === '/admin/audience-category' ? ' active' : ''}`} to="/admin/audience-category">
            Kategori Peserta
          </Link>
          <Link className={`dropdown-item${currentPath === '/admin/audience-category-detail' ? ' active' : ''}`} to="/admin/audience-category-detail">
            Kategori Peserta Biaya
          </Link>
          <Link className={`dropdown-item${currentPath === '/admin/workshop' ? ' active' : ''}`} to="/admin/workshop">
            Workshop
          </Link>
          <Link className={`dropdown-item${currentPath === '/admin/hotel' ? ' active' : ''}`} to="/admin/hotel">
            Hotel
          </Link>
          {/* <Link className={`dropdown-item${currentPath === '/admin/accomodation' ? ' active' : ''}`} to="/admin/accomodation">
            Akomodasi
          </Link> */}
        </div>
      </li>

      {/* Dropdown: Monitoring Event */}
      <li className={`nav-item dropdown${openDropdowns.monitoring ? ' show' : ''}`}>
        <a
          className={`nav-link dropdown-toggle${isPathInCategory(monitoringPaths) ? ' active' : ''}`}
          href="#"
          onClick={e => toggleDropdown('monitoring', e)}
          role="button"
          aria-expanded={openDropdowns.monitoring}
        >
          <i className="bi bi-graph-up-arrow me-2" />
          Monitoring Event
        </a>
        <div className={`dropdown-menu${openDropdowns.monitoring ? ' show' : ''}`}>
          <Link className={`dropdown-item${currentPath === '/admin/monitoring-peserta' ? ' active' : ''}`} to="/admin/monitoring-peserta">
            Monitoring Peserta
          </Link>
          <Link className={`dropdown-item${currentPath === '/admin/monitoring-pembayaran' ? ' active' : ''}`} to="/admin/monitoring-pembayaran">
            Monitoring Pembayaran
          </Link>
        </div>
      </li>

      {/* Dropdown: Report */}
      <li className={`nav-item dropdown${openDropdowns.users ? ' show' : ''}`}>
        <a
          className={`nav-link dropdown-toggle${isPathInCategory(usersPaths) ? ' active' : ''}`}
          href="#"
          onClick={e => toggleDropdown('users', e)}
          role="button"
          aria-expanded={openDropdowns.users}
        >
          <i className="bi bi-file-earmark-bar-graph-fill me-2" />
          Report
        </a>
        <div className={`dropdown-menu${openDropdowns.users ? ' show' : ''}`}>
          {/* <Link className={`dropdown-item${currentPath === '/admin/masterdata-internal-users' ? ' active' : ''}`} to="/admin/masterdata-internal-users">
            Download by CSV
          </Link>
          <Link className={`dropdown-item${currentPath === '/admin/masterdata-external-users' ? ' active' : ''}`} to="/admin/masterdata-external-users">
            Download by Excel
          </Link> */}
          <Link className="dropdown-item" to="/admin/download-report">
            Download Laporan
          </Link>
        </div>
      </li>
      
      {/* Logout */}
      <li className="nav-item">
        <button className="nav-link text-danger"   onClick={handleLogout} >
          <i className="bi bi-box-arrow-right me-2" />
          Logout
        </button>
      </li>

    </ul>
  );
};

export default NavLinks;
